import api from './http'

/* *****문의하기 FRONT API***** */

// uploadAttachFile
const saveUpload = (questionType, data, callback, errorHandler) => {
  return api.getPromise('POST', `/api/question/${questionType}/attach-upload`, data, { isMultipart: true })
}

// sendQuestion
const saveQuestion = (data, callback, errorHandler) => {
  return api.getPromise('POST', '/api/question/send', data)
}

export default {
  saveUpload,
  saveQuestion,
}
